import { IOrganization } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";

interface IProps {
    /**
     * the organization to view
     */
    organization: IOrganization;
}

/**
 * A button to navigate to the organization's home page
 */
export const ViewOrganizationButton = ({ organization }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy();

    return (
        <Button
            variant="contained"
            color={"inherit"}
            onClick={() => proxyIntoOrganization(organization.id)}
            loading={isPending}
            sx={{ borderRadius: 29 }}
            disableElevation
        >
            View Organization
        </Button>
    );
};
